import { render } from "./TripEditDialog.vue?vue&type=template&id=31bd461a"
import script from "./TripEditDialog.vue?vue&type=script&lang=js"
export * from "./TripEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__